import { forwardRef } from "react";
import { TextField, type TextFieldProps } from "@/shared/ui/primitives/TextField";

export interface AmountFieldProps extends Omit<TextFieldProps, "value" | "onChange" | "suffix"> {
  value: number | null;
  onChange: (value: number | null) => void;
  unit?: "kr" | "SEK";
}

export const AmountField = forwardRef<HTMLInputElement, AmountFieldProps>(function AmountField(
  { value, onChange, unit = "kr", ...rest },
  ref,
) {
  return (
    <TextField
      ref={ref}
      inputMode="numeric"
      value={formatAmount(value)}
      onChange={(event) => onChange(parseAmount(event.target.value))}
      suffix={unit}
      className="font-quant"
      {...rest}
    />
  );
});

export function formatAmount(value: number | null): string {
  if (value === null || !Number.isFinite(value)) return "";
  return Math.round(value)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

export function parseAmount(text: string): number | null {
  const digits = text.replace(/[^\d-]/g, "");
  if (digits === "" || digits === "-") return null;
  const value = Number.parseInt(digits, 10);
  return Number.isFinite(value) ? value : null;
}
